import * as React from 'react'
const TriangleAlert = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={40}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#004360"
        d="M19.438 4.201c1.17-1.917 3.954-1.917 5.123 0l17.52 28.737c1.22 2-.22 4.562-2.561 4.562H4.48c-2.342 0-3.781-2.563-2.562-4.562l17.52-28.737Z"
      />
      <ellipse cx={22} cy={30.912} fill="#fff" rx={1.76} ry={1.818} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={4}
        d="M21.76 25.273V14.728"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h44v40H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default TriangleAlert
